// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root___wb-M","footer":"ModalCreateQualiphyProcedure_footer__2DdoP","additionData":"ModalCreateQualiphyProcedure_additionData__3foNh"};